export enum CookiesConstants {
  PHONE_COOKIE_NAME = `token_SM_DRIVERS_PHONE`,
  SM_DRIVERS_COOKIE_NAME = `token_SM_DRIVERS`,
}
